var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tips"},[_c('h3',{staticClass:"title-group"},[_vm._v("5、上传素材")]),_c('div',{staticClass:"tips mb20"},[_c('p',{staticClass:"text-color-gray"},[_vm._v("创建说明：按照调用的智能投放类型计划的规格（图片、视频数量）匹配上传的创意，上传的创意数量大于一个计划规格数量时，将创建第二个计划，以此类推。")])])])
}]

export { render, staticRenderFns }